import React, { useEffect, useState } from 'react'

const Products = () => {
  const [products,setProducts]=useState(null);
 const longText = `
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur fermentum 
    libero a justo gravida, at pretium nisi blandit. Suspendisse vitae dolor 
    tristique, fermentum purus vitae, vulputate metus. Integer feugiat turpis 
    ac tortor convallis, nec bibendum sapien euismod. Sed a nisi vitae metus 
    efficitur blandit. Vivamus vel velit nec diam ullamcorper mattis. Mauris 
    varius libero vel augue blandit, non pretium elit scelerisque. 
    Pellentesque habitant morbi tristique senectus et netus et malesuada fames 
    ac turpis egestas. Aenean ac porta risus. Cras ac ligula ac tortor 
    tristique bibendum. Proin malesuada nibh eget sapien fermentum, at feugiat 
    magna congue. Nam vel massa vitae diam malesuada tincidunt.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur fermentum libero a justo gravida, at pretium nisi blandit. Suspendisse vitae dolor 
    tristique, fermentum purus vitae, vulputate metus. Integer feugiat turpis 
    ac tortor convallis, nec bibendum sapien euismod. Sed a nisi vitae metus 
    efficitur blandit. Vivamus vel velit nec diam ullamcorper mattis. Mauris 
    varius libero vel augue blandit, non pretium elit scelerisque. 
    Pellentesque habitant morbi tristique senectus et netus et malesuada fames 
    ac turpis egestas. Aenean ac porta risus. Cras ac ligula ac tortor 
    tristique bibendum. Proin malesuada nibh eget sapien fermentum, at feugiat 
    magna congue. Nam vel massa vitae diam malesuada tincidunt.
  `;
  useEffect(()=>{
    const fetchProducts=async()=>{
      const response=await fetch("")
    }
  },[])
  return (
    <div style={{ padding: '16px', maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc',backgroundColor:"0px 5px 40px rgba(194, 212, 159, 0)",marginTop:'30px',textAlign:'justify',color:'white',marginBottom:'415px'}}>
      <p>{longText}</p>
    </div>
  )
}

export default Products
